module.exports = __webpack_public_path__ + "media/theme/icon__footer--payment-f4d8bb94.svg";